import React, { useEffect, useState } from 'react'

import { encryptStorage, workDayURL} from '../constant'

/**
 * PC_MTc_04 getMyToDoData gets imported from api.js file
 */
import { getMyToDoData } from '../service/api'
import '../components/css/Dashboard-styles.css'

import moment from 'moment'



const MyToDoData = () => {

    /**
 * PC_MTc_02
 * The data , todoVal state variable is created for storing the response data
 */

    const [data, setData] = useState([])

    const [todoVal, setTodoVal] = useState(0)

    /**
  * PC_MTc_03
  * Use Efffect method is called 
  */

    useEffect(() => {

        fetchApi()

    }, [])


    /**
 * PC_MTc_06
 * The fetchApi function in the useEffects gets invoked which inturn call the getMyTodoData() function with respective parameters
 */

    const fetchApi = async () => {

        const resp = await getMyToDoData();

    

        if (resp?.data?.length) {

            setData(resp.data)

            setTodoVal(resp?.data?.length)
        }

    }


    const todoStatus = (status) => {

        if ((status.toLowerCase().includes('progress'))) return 'dash-working-on-it-status'
        else if ((status.toLowerCase().includes('yet to start'))) return 'dash-yet-to-start-status'
        else if ((status.toLowerCase().includes('completed'))) return 'dash-completed-status'
        else if ((status.toLowerCase().includes('hold'))) return 'dash-hold-status'
    }

    const todoPriority = (priority) => {

        if (priority.toLowerCase().includes('high')) return 'dashboard-highpriority-border'
        else if (priority.toLowerCase().includes('medium')) return 'dashboard-medium-priority-option'
        else if (priority.toLowerCase().includes('low')) return 'dashboard-low-priority-option'
    }


    /**
* PC_MTc_10
* The response data gets stored in the data variable and mapped to the respective divs
*/

    const myToDoBody = () => {

        /*<span className={todoPriority(datum.priority)} /> */



        return (

            data.map((datum, i) => {

                if (i < 6) return (
                    <>
                        <tr className="dashboard-td-style " style={{ cursor: 'pointer' }}>
                            <td className="dashboard-td-style font-12 medium-text text-break" title={datum.work_item}> <span className={`dashboard-medium-priority-option`} />{datum.work_item.length > 30 ? datum.work_item.substring(0, 30) + "..." : datum.work_item}</td>
                            <td className="dashboard-td-style font-12 medium-text">{moment(datum.due_date).format('MMM DD, YYYY')}</td>
                            <td className="dashboard-td-style font-12 medium-text text-end">{datum.estimated_hours}</td>
                            <td className="dashboard-td-style font-12 medium-text text-end">{(datum.actual_hours) ? datum.actual_hours : "-"}</td>
                            <td className="dashboard-td-style  text-center"><span className={`badge dashboard-badge ${todoStatus(datum.status)} ${(datum.status.includes('working on it')) ? `dashboard-todo-status` : ``} py-2 px-3 font-12 medium-text`}>{datum.status}</span></td>
                        </tr>
                    </>
                )
            })
        )
    }



    return (

        <div className="custom-col-70 rounded-5 dashboard-container-background p-3">
            <div className="d-flex justify-content-between ">
                <h1 className="tt-bold font-15">{`My Todo (${todoVal})`}</h1>
                {/* <a href={`https://workdaynp.avasoft.com/apiservice/hive/${encryptStorage.getItem("userId")}/myTODO?date=${moment().format("YYYY-MM-DD")}&action=add-todo`} className="semibold-text font-12 pe-3 text-decoration-none"><span><img src="/Images/Add button.png" className="dashboard-add-arrow-size me-1 " /></span>Add</a> */}
                <a href={`${workDayURL}#/${encryptStorage.getItem("userId")}/myTODO?date=${moment().format("YYYY-MM-DD")}&action=add-todo`} className="semibold-text font-12 pe-3 text-decoration-none"><span><img src="/Images/Add button.png" className="dashboard-add-arrow-size me-1 " /></span>Add</a>
            </div>
            <table className="dashboard-table-style font-12">
                <thead>
                    <tr className="dashboard-th-style">
                        <th className="py-2 ps-3">Work Item</th>
                        <th className="py-2">Due Date</th>
                        <th className="text-end py-2">ETA(Hrs)</th>
                        <th className="text-end py-2">Actual(Hrs)</th>
                        <th className="text-center py-2">Status</th>
                    </tr>
                </thead>
                <tbody>
                    {myToDoBody()}
                </tbody>
            </table>
            <div className="text-end">
                {/* <a href={`https://workdaynp.avasoft.com/apiservice/hive/${encryptStorage.getItem("userId")}/myTODO?date=${moment().format("YYYY-MM-DD")}&action=view-todo`} className="semibold-text font-12 pe-3 text-decoration-none ">View all<span><img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" /></span></a> */}
                <a href={`${workDayURL}`} className="semibold-text font-12 pe-3 text-decoration-none ">View all<span><img src="/Images/view all.png" className="dashboard-view-arrow-size ms-1" /></span></a>
            </div>
        </div>
    )
}

export default MyToDoData